export const LOGIN_COMPLETED = "LOGIN_COMPLETED";
export const FETCH_COMPANY_ID_COMPLETED = "FETCH_COMPANY_ID_COMPLETED";
